var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539917,
    y: 0.280029,
    width: 46.6,
    height: 46.6,
    rx: 23.3,
    fill: "#0043CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6341 29.1408C21.3234 29.1408 21.0283 29.0166 20.8108 28.7991L16.4149 24.4032C15.9644 23.9527 15.9644 23.2071 16.4149 22.7566C16.8653 22.3062 17.6109 22.3062 18.0614 22.7566L21.6341 26.3293L29.6182 18.3452C30.0687 17.8947 30.8143 17.8947 31.2647 18.3452C31.7152 18.7956 31.7152 19.5412 31.2647 19.9917L22.4573 28.7991C22.2399 29.0166 21.9447 29.1408 21.6341 29.1408Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperChecked);
export default __webpack_public_path__ + "static/media/stepper-checked.c558146e062aafca7030196771d00b2d.svg";
export { ForwardRef as ReactComponent };